import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FooterLogoSVG from './solero-logo.png';
import {Link} from 'react-router-dom';
import './FooterLogo.css';

/**
 * Footer Logo - Global Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class FooterLogo extends Component {

    /**
     * Default Props
     *
     * @type {{url: string, text: string, alt: string}}
     */
    static defaultProps = {
        url: '',
        text: '',
        alt: ''
    };

    /**
     * Prop types
     *
     * @type {{url: shim, text: shim, alt: shim}}
     */
    static propTypes = {
        url: PropTypes.string,
        text: PropTypes.string,
        alt: PropTypes.string
    };

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {alt, text, url} = this.props;

        return (
            <div>
                <Link to={url}>
                    <img src={FooterLogoSVG}
                         className="Footer-logo"
                         alt={alt}/>
                </Link>
                <p className="SmallPrint">{text}</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/footer/footerLogo/FooterLogo.jsx